import { LocalStorageData } from "../../Models/Client/LocalStorage"
import createValidator from "ajv"
import schema from "../../Helpers/Schema/localStorage.json"

const KEY = "appData"
const validator = createValidator()

export function load(): LocalStorageData | undefined {
    try {
        const raw = localStorage.getItem(KEY)

        if (raw === null) return undefined

        const parsed = JSON.parse(raw)

        if (!validator.validate(schema, parsed)) {
            console.warn(
                `Invalid local storage content detected at key ${KEY}. Will clear values.`
            )

            clear()

            return undefined
        }

        return parsed as LocalStorageData
    } catch (e) {
        return undefined
    }
}

export function save(value: LocalStorageData): void {
    localStorage.setItem(KEY, JSON.stringify(value))
}

export function clear(): void {
    localStorage.removeItem(KEY)
}
